module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_2-80e54ef69d7a84b9b22fe99e45d4ca25.jpg";